import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import FeuD5QuaysideAndAnchorage from './FeuD5QuaysideAndAnchorage/FeuD5QuaysideAndAnchorage';
import FeuD4SailingInIce from './FeuD4SailingInIce/FeuD4SailingInIce';
import FeuD3DistanceTravelled from './FeuD3DistanceTravelled/FeuD3DistanceTravelled';
import FeuD2EstimateEngeryConsumption from './FeuD2EstimateEngeryConsumption/FeuD2EstimateEngeryConsumption';
import FeuD1EstimateFuelConsumption from './FeuD1EstimateFuelConsumption/FeuD1EstimateFuelConsumption';

const FeuDataGaps = ({ FeuDataGapsData, refetchMonitoringData, dropdownData,vesselMstId }) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');

    // const handleChange = (panel) => (_, isExpanded) => {
    //     setExpandedPanel(isExpanded ? panel : false);
    // };

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
            NameOfTheShip: '',
        },
    });

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );

    const handleAutoSave = (field, value) => {
        // Add your API call here
        // Example:
        // api.patch('/saveField', { [field]: value });
    };

    const autoSaveForD1 = useRef();
    const autoSaveForD2 = useRef();
    const autoSaveForD3 = useRef();
    const autoSaveForD4 = useRef();
    const autoSaveForD5 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedPanel === 'panel1' && autoSaveForD1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForD2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD2.current.submitAndCheck();
        } else if (expandedPanel === 'panel3' && autoSaveForD3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD3.current.submitAndCheck();
        } else if (expandedPanel === 'panel4' && autoSaveForD4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD4.current.submitAndCheck();
        } else if (expandedPanel === 'panel5' && autoSaveForD5.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD5.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        // clearErrors();
        setExpandedPanel(isExpanded ? panel : false);
    };

    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'D.1 Methods to be used to estimate fuel consumption')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuD1EstimateFuelConsumption ref={autoSaveForD1} D1GhgAndFuelConsumptionData={FeuDataGapsData?.d1GasEmissions} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} vesselMstId={vesselMstId}  />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel2', 'D.2 Methods to be used to estimate energy consumption from OPS and ZET (where applicable)')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuD2EstimateEngeryConsumption ref={autoSaveForD2} D2FeuEstimateEngeryConsumptionData={FeuDataGapsData?.d2EnergyConsumptionOPSZET} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} vesselMstId={vesselMstId}  />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel3'} onChange={handleChange('panel3')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel3', 'D.3 Methods to be used to treat data gaps regarding distance travelled')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuD3DistanceTravelled ref={autoSaveForD3} D3FeuDistanceTravelledData={FeuDataGapsData?.d3DataGaps} refetchMonitoringData={refetchMonitoringData} vesselMstId={vesselMstId}  />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel4'} onChange={handleChange('panel4')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel4', 'D.4 Methods to be used to treat data gaps regarding the date, time and position when entering and leaving the ice conditions, the distance travelled when sailing in ice conditions')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuD4SailingInIce ref={autoSaveForD4} D4FeuSailingInIceData={FeuDataGapsData?.d4DataGapsForIceTransit} refetchMonitoringData={refetchMonitoringData} vesselMstId={vesselMstId}  />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel5'} onChange={handleChange('panel5')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel5', 'D.5 Methods to be used to treat data gaps regarding time spent at sea and time spent at berth (quayside and anchorage) (where applicable)')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <FeuD5QuaysideAndAnchorage ref={autoSaveForD5} D5FeuQuaysideAndAnchorageData={FeuDataGapsData?.d5DataGapsForTimeAtSeaBerth} refetchMonitoringData={refetchMonitoringData} vesselMstId={vesselMstId}  />
                    </AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
}

export default FeuDataGaps;
